import { render } from "./ForgotPassword.vue?vue&type=template&id=ae47d9ea&scoped=true&bindings={\"email\":\"data\",\"error\":\"data\",\"emailValidationError\":\"data\",\"successMessage\":\"data\",\"submitForm\":\"options\",\"closeAlert\":\"options\",\"onEmailKeyUp\":\"options\",\"emailHasError\":\"options\",\"showEmailErrors\":\"options\"}"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=ae47d9ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ae47d9ea"

export default script